module.exports = __webpack_public_path__ + "static/media/instruction-step3.c00ff821.png";